// Copyright (c) 2019 Deere & Company

import WearPartsClaimContainer from '../../claim/wear-parts/state-connector';

export default {
    component: WearPartsClaimContainer,
    name: 'WEAR_PARTS',
    path: 'wear-parts/edit/:claimNumber'
};



// WEBPACK FOOTER //
// ./src/routes/claims/edit-wear-parts-claim-route.js